import React, { useState, useEffect } from "react";
import "./case-homepage.scss";
import { Tabs } from "@veneer/core";
import { useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import Recentcases from "./cases/recentcases";
import Favouritecases from "./cases/favouritecase";
import { WelcomeBanner } from "../shared-components/welcome-banner";
import { SearchCases } from "./cases/searchcases";
import { OnPageLoad_POST } from "../../../services";
import { apiPost } from "../../../services/service";
import MyOrders from "./cases/myorders";
import Favourite from "./cases/favourite";
import Loader from "../shared-components/loader/loader";
import { useTranslation } from "react-i18next";

const HomePage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const [recentcase, setRecentcase] = React.useState<any>([]);
  const [siteSubAccount, setSiteSubAccount] = React.useState<any[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [progress, setProgress] = useState<boolean>(false);
  window.localStorage.removeItem("signupcompleted");
  const IsIndividualRole: boolean = (window as any).IsIndividualRole || false;
  const {t} = useTranslation();
  const changeTabHandler = (id: any) => {
    setActiveTab(id);
  };
  const addloader = () => {
    setProgress(true);
  };

  const resBtn = (data: any) => {
    let uri = `cid=${data.incidentid}`;
    return (
      <button
        className="link"
        onClick={() => {
          navigate(`/edit-case?${uri}`, { state: { data } });
        }}
      >
        {data.hpi_caseid}
      </button>
    );
  };

  const userDetails = async () => {
    try {
      setProgress(true);
      const payload = {
        contactid: "85680c15-7814-e711-80fc-5065f38ad971",
        accountid: "f16eeb64-73fc-e611-80fa-5065f38ad971",
        tabid: "RecentCases",
        submittedbyme: false,
      };
      
      const res = await apiPost(OnPageLoad_POST, payload);
      setIsLoading(false);
      if (res.data && res.data.RecentCases) {
        let updatedcases = JSON.parse(res.data.RecentCases).map(
          (incident: any) => ({
            ...incident,
            hpi_caseid: resBtn(incident),
            favourite: (
              <Favourite
                caseId={incident.incidentid}
                favourite={incident.favourite}
                pageload={userDetails}
                tableid={"favourite_cases"}
                loader={addloader}
              />
            ),
          })
        );
        setRecentcase(updatedcases);
        setSiteSubAccount(JSON.parse(res?.data?.siteSubAccount));
        setProgress(false);
      } else {
        setProgress(false);
      }
    } catch (error) {
      console.error("Error fetching recent cases:", error);
      setProgress(false);
    }
  };

  useEffect(() => {
    userDetails();
  }, []);

  return (
    <>
      <Container fluid>
        {progress && (
          <div className="loader-overlay">
            <div className="loader-css">
              <Loader />
            </div>
          </div>
        )}
        <div className="home-page-container">
          <div className="banner-container-wellcome">
            <Row>
              <WelcomeBanner />
            </Row>
            <div className="body-section">
              <Col className="body-container">
                <Tabs
                  controlId="default"
                  mode="contained"
                  className="tabs-container"
                  onChangeTab={changeTabHandler}
                  selectedTabId={activeTab}
                  tabs={[
                    {
                      id: 0,
                      label: t('HPI.MainHomePage.My Cases',{defaultValue:'My Cases'}),
                      content: (
                        <Row>
                          <div className="container inner-container">
                            <div className="tab-pane active " id="Recentcases">
                              <Recentcases />
                            </div>
                          </div>
                        </Row>
                      ),
                    },
                    {
                      id: 1,
                      label: t('HPI.MainHomePage.FavouriteCases',{defaultValue:'Favorite Cases'}),
                      content: (
                        <Row className="">
                          <div className="container inner-container">
                            <div className="tab-pane active " id="my">
                              <Favouritecases />
                            </div>
                          </div>
                        </Row>
                      ),
                    },
                    ...(!IsIndividualRole
                      ? [
                    {
                      id: 2,
                      label: t('HPI.MainHomePage.SearchCases',{defaultValue:'Search Cases'}),
                      content: (
                        <Row className="">
                          <div className="container inner-container pt-4">
                            <div className="tab-pane active " id="my">
                              <SearchCases siteSubAccount={siteSubAccount} />
                            </div>
                          </div>
                        </Row>
                      ),
                     },] : []),

                    {
                      id: 3,
                      label: t('HPI.MainHomePage.myorders',{defaultValue:'My Orders'}),
                      content: (
                        <Row>
                          <div className="container inner-container">
                            <div className="tab-pane active " id="Recentcases">
                              <MyOrders />
                            </div>
                          </div>
                        </Row>
                      ),
                    },
                  ]}
                  type="attached"
                />
              </Col>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default HomePage;
